import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "shadowed-card bg-white mb-2 p-3"
}
const _hoisted_2 = { class: "d-flex align-items-center mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "check-wrap mr-3"
}
const _hoisted_4 = { class: "form-group mb-0" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "badge badge-warning text-white" }
const _hoisted_7 = { class: "shadowed-card-header" }
const _hoisted_8 = {
  key: 0,
  class: "card-title"
}
const _hoisted_9 = { class: "file-actions mt-2 mr-2" }
const _hoisted_10 = { class: "dropdown" }
const _hoisted_11 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "true"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-v" })
], -1)
const _hoisted_12 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye mr-2" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("View Details")
const _hoisted_15 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_16 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "far fa-edit mr-1" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("small", null, [
  /*#__PURE__*/_createVNode("strong", null, "View Tasks")
], -1)
const _hoisted_19 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "far fa-edit mr-1" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" No Task Added ")
const _hoisted_22 = {
  key: 3,
  class: "mb-1"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar mr-2" }, null, -1)
const _hoisted_24 = { class: "text-danger" }
const _hoisted_25 = {
  key: 4,
  class: "mb-1"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar mr-2" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("N/A")
const _hoisted_28 = { key: 5 }
const _hoisted_29 = /*#__PURE__*/_createVNode("strong", null, " Status : ", -1)
const _hoisted_30 = { key: 6 }
const _hoisted_31 = /*#__PURE__*/_createVNode("strong", null, "Status : ", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" N/A")
const _hoisted_33 = { key: 7 }
const _hoisted_34 = /*#__PURE__*/_createVNode("strong", null, " Priority : ", -1)
const _hoisted_35 = {
  key: 0,
  class: "green-text"
}
const _hoisted_36 = {
  key: 1,
  class: "yellow-text"
}
const _hoisted_37 = {
  key: 2,
  class: "yellow-text"
}
const _hoisted_38 = { key: 8 }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "inline-items mt-3" }, [
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("i", { class: "fa fa-paperclip mr-1" }),
      /*#__PURE__*/_createTextVNode(" 0")
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("i", { class: "far fa-comments mr-1" }),
      /*#__PURE__*/_createTextVNode(" 0")
    ])
  ])
], -1)
const _hoisted_40 = { class: "mt-3" }
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "fa fa-user-plus" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Add Member")
const _hoisted_43 = { class: "modal-wrap default-modal" }
const _hoisted_44 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "showTasks",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_45 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_46 = { class: "modal-content" }
const _hoisted_47 = { class: "modal-header" }
const _hoisted_48 = { class: "d-block" }
const _hoisted_49 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_51 = { class: "modal-body" }
const _hoisted_52 = { class: "form-wrap pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoPhaseStatus = _resolveComponent("ToDoPhaseStatus")
  const _component_ToDoMembersList = _resolveComponent("ToDoMembersList")
  const _component_ToDoPhaseDetailTasks = _resolveComponent("ToDoPhaseDetailTasks")
  const _component_ToDoListAddPhaseModal = _resolveComponent("ToDoListAddPhaseModal")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.phaseData, (phase, phaseIndex) => {
      return (_openBlock(), _createBlock("div", {
        class: "col-md-4 px-2",
        key: phaseIndex
      }, [
        phase
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                (_ctx.role===1)
                  ? (_openBlock(), _createBlock("div", _hoisted_3, [
                      _createVNode("div", _hoisted_4, [
                        _withDirectives(_createVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => (phase.isSelected = $event),
                          id: "checkbox",
                          name: "checkbox1",
                          onChange: ($event: any) => (_ctx.toggleItemCheck(phase)),
                          disabled: phase.status_detail.status.id!=1 && phase.status_detail.status.id!=3 && phase.status_detail.status.id!=5
                        }, null, 40, ["onUpdate:modelValue", "onChange", "disabled"]), [
                          [_vModelCheckbox, phase.isSelected]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (phase.label)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _createVNode("span", _hoisted_6, " Phase " + _toDisplayString(phase.label), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_7, [
                (phase.name)
                  ? (_openBlock(), _createBlock("h3", _hoisted_8, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.viewSelectedPhaseDetails(phase))
                      }, _toDisplayString(phase.name), 9, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode("div", _hoisted_12, [
                      (_ctx.isActive(phase.permissions, 'view_phase_detail'))
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.viewSelectedPhaseDetails(phase))
                          }, [
                            _hoisted_13,
                            _hoisted_14
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (phase.description)
                ? (_openBlock(), _createBlock("p", _hoisted_15, [
                    _createVNode("small", null, _toDisplayString(phase.description), 1)
                  ]))
                : _createCommentVNode("", true),
              (phase.child_phases && phase.child_phases.length)
                ? (_openBlock(), _createBlock("p", _hoisted_16, [
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(phase.child_phases.length) + " Tasks - ", 1),
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "text-primary",
                      onClick: ($event: any) => (_ctx.viewTasksByPhase(phase))
                    }, [
                      _hoisted_18
                    ], 8, ["onClick"])
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_19, [
                    _hoisted_20,
                    _hoisted_21
                  ])),
              (phase.localStartedDate || phase.localEndDate)
                ? (_openBlock(), _createBlock("p", _hoisted_22, [
                    _createVNode("small", null, [
                      _hoisted_23,
                      _createTextVNode(" " + _toDisplayString(phase.localStartedDate) + " - ", 1),
                      _createVNode("span", _hoisted_24, _toDisplayString(phase.localEndDate), 1)
                    ])
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_25, [
                    _hoisted_26,
                    _hoisted_27
                  ])),
              (phase.status_detail.status)
                ? (_openBlock(), _createBlock("p", _hoisted_28, [
                    _hoisted_29,
                    _createVNode(_component_ToDoPhaseStatus, {
                      phase: phase.status_detail.status.name
                    }, null, 8, ["phase"])
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_30, [
                    _hoisted_31,
                    _hoisted_32
                  ])),
              (phase.priority_id)
                ? (_openBlock(), _createBlock("p", _hoisted_33, [
                    _hoisted_34,
                    (phase.priority_id === 3)
                      ? (_openBlock(), _createBlock("span", _hoisted_35, "High"))
                      : (phase.priority_id === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_36, "Medium"))
                        : (_openBlock(), _createBlock("span", _hoisted_37, "Low"))
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_38, "Priority : N/A")),
              _hoisted_39,
              (phase.allMembers && phase.allMembers.length)
                ? (_openBlock(), _createBlock(_component_ToDoMembersList, {
                    key: 9,
                    projectMembers: phase.allMembers
                  }, null, 8, ["projectMembers"]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_40, [
                (_ctx.isActive(phase.permissions, 'view_phase_detail'))
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      href: "javascript:void(0)",
                      class: "btn default-btn me-2",
                      onClick: ($event: any) => (_ctx.viewSelectedPhaseDetails(phase))
                    }, " View Details", 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isActive(phase.permissions, 'add_member_to_phase'))
                  ? (_openBlock(), _createBlock("a", {
                      key: 1,
                      href: "javascript:void(0)",
                      class: "btn default-btn outline",
                      onClick: ($event: any) => (_ctx.redirectToAddMember(phase.uuid))
                    }, [
                      _hoisted_41,
                      _hoisted_42
                    ], 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createVNode("div", _hoisted_43, [
      _createVNode("div", _hoisted_44, [
        _createVNode("div", _hoisted_45, [
          _createVNode("div", _hoisted_46, [
            _createVNode("div", _hoisted_47, [
              _createVNode("div", _hoisted_48, [
                _createVNode("h5", _hoisted_49, _toDisplayString(_ctx.state.data.selectedPhase.name) + "'s Task List", 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideTasksModal && _ctx.hideTasksModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_50
              ])
            ]),
            _createVNode("div", _hoisted_51, [
              _createVNode("div", _hoisted_52, [
                (_ctx.state.data.taskLists && _ctx.state.data.taskLists.length)
                  ? (_openBlock(), _createBlock(_component_ToDoPhaseDetailTasks, {
                      key: 0,
                      subPhases: _ctx.state.data.taskLists,
                      showAction: false
                    }, null, 8, ["subPhases"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showAddPhaseModal)
      ? (_openBlock(), _createBlock(_component_ToDoListAddPhaseModal, {
          key: 0,
          editMode: _ctx.state.data.editMode,
          editFrom: _ctx.state.data.editFrom,
          editData: _ctx.state.data.selectedToEdit,
          showAddPhase: _ctx.state.data.showAddPhaseModal,
          projectDetail: _ctx.project,
          projectAcknowledgementDetail: _ctx.details,
          onClose: _ctx.showAddPhaseModal,
          onEditSelected: _ctx.updateSelected
        }, null, 8, ["editMode", "editFrom", "editData", "showAddPhase", "projectDetail", "projectAcknowledgementDetail", "onClose", "onEditSelected"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 1,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFullMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}